import { connect } from 'react-redux';
import LoginComponent from './LoginForm';
import {
  getEmail,
  getPassword,
  getError,
  getEmailError,
  getPasswordError,
  canLogin,
  isAuthenticating,
  shouldShowEmailError,
  shouldShowPasswordError,
  isAuthenticated,
} from '../../../state/reducers/LoginReducer';
import LoginActions from '../../../state/actions/LoginActions';
// import { JwtSelector } from '../../../state/reducers/Jwt';

const mapStateToProps = (state) => ({
  email: getEmail(state),
  emailError: shouldShowEmailError(state) ? getEmailError(state) : '',
  password: getPassword(state),
  passwordError: shouldShowPasswordError(state) ? getPasswordError(state) : '',
  loginError: getError(state),
  canLogin: canLogin(state),
  authenticating: isAuthenticating(state),
  isAuthenticated: isAuthenticated(state), // !JwtSelector.isTokenExpired(state),
});

const { loginRequest, emailChanged, passwordChanged } = LoginActions;

export default connect(mapStateToProps, {
  emailChanged,
  passwordChanged,
  login: loginRequest,
})(LoginComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Login/index.js